import { Button, Chip, Fade, makeStyles, TextField, Typography } from '@material-ui/core';
import { useContext, useEffect, useState } from 'react';
import { transitionTimeout } from './ClaimWizard';
import { separations } from '../../../constants/StyleConstants';
import { AttachFile } from '@material-ui/icons';
import DropZone from '../../../components/UI/DropZone';
import OutlinedDiv from '../../../components/UI/OutlinedDiv';
import { ClaimContext } from '../../../contexts/ClaimContext';
import { AppContext } from '../../../contexts/AppContext';
import ClaimsAPI from '../../../services/ClaimsAPI';
import { uuidv4 } from '../../../utils/MiscellaneousUtils';

const useStyles = makeStyles(theme => ({
  ...separations,
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  supplierChip: {
    margin: 2,
  },
  supplierChipsWrapper: {
    marginTop: 10,
  },
}));

const ImproperRetention = () => {
  const classes = useStyles();
  const { showError, showWarning } = useContext(AppContext);
  const [transIn, setTransIn] = useState(true);
  const [description, setDescription] = useState('');
  const [dropZoneTransIn, setDropZoneTransIn] = useState(false);
  const [attachedFiles, setAttachedFiles] = useState([]);
  const { setStepElements, setOpenBackDrop, selectedClaimId } = useContext(ClaimContext);

  useEffect(() => {
    const step = {
      stepNumber: 1,
      backButtonText: 'Cancelar y elegir otro tipo de reclamo',
      finishButtonText: 'Iniciar reclamo',
      finishButtonAction: () => sendClaim(description, attachedFiles),
      transition: {
        enter: () => setTransIn(true),
        exit: () => setTransIn(false),
      },
    };

    setStepElements(step.stepNumber, step);
  }, [description, attachedFiles]);

  const handleFiles = files => {
    setAttachedFiles([...attachedFiles, files[0]]);
    setDropZoneTransIn(false);
  };

  const deleteAttachment = attachment => {
    setAttachedFiles(attachedFiles.filter(file => file !== attachment));
  };

  const handleChangeDescription = value => {
    if (value.isBlank()) {
      setDescription('');
    } else {
      setDescription(value);
    }
  };

  const validate = () => {
    let errors = [];
    const errorMessages = [];
    let i = 0;

    if ((errors[i++] = description.isBlank())) errorMessages.push('Debe ingresar una descripción');

    const hasErrors = errors.some(e => e);

    hasErrors && showWarning(errorMessages);

    return !hasErrors;
  };

  const sendClaim = (description, attachedFiles) => {
    return new Promise((resolve, reject) => {
      if (validate()) {
        setOpenBackDrop(true);

        const request = {
          idType: selectedClaimId,
          description: description,
          files: attachedFiles.length,
          filesId: uuidv4(),
        };

        if (!attachedFiles.isEmpty()) {
          ClaimsAPI.uploadFile(request.filesId, attachedFiles)
            .then(res => {
              ClaimsAPI.startClaim(request)
                .then(res => resolve())
                .catch(error => {
                  setOpenBackDrop(false);
                  showError('Error al iniciar reclamo');
                });
            })
            .catch(error => {
              setOpenBackDrop(false);
              showError('Error al iniciar reclamo, no se pudieron adjuntar los archivos al reclamo');
            });
        } else {
          ClaimsAPI.startClaim(request)
            .then(res => resolve())
            .catch(error => {
              setOpenBackDrop(false);
              showError('Error al iniciar reclamo');
            });
        }
      } else {
        reject();
      }
    });
  };

  const handleAttachment = () => {
    setDropZoneTransIn(true);
  };

  return (
    <DropZone open={dropZoneTransIn} setOpen={setDropZoneTransIn} handleFiles={handleFiles}>
      <Fade in={transIn} timeout={transitionTimeout}>
        <div className={classes.root}>
          <Typography variant="subtitle2">Adjunte constancia de exclusión y/o certificado de alícuota a aplicar</Typography>
          <TextField
            className={classes.topSeparation}
            margin="dense"
            id="description"
            multiline
            rows={5}
            variant="outlined"
            label="Descripción"
            onChange={e => handleChangeDescription(e.target.value)}
            value={description}
          />
          <div>
            {!attachedFiles.isEmpty() && (
              <Fade in={true}>
                <div className={classes.lineSpacingSeparation}>
                  <OutlinedDiv label="Archivos adjuntos">
                    {attachedFiles.map(att => (
                      <Chip
                        className={classes.supplierChip}
                        size="small"
                        label={att.name}
                        onDelete={() => deleteAttachment(att)}
                        color="primary"
                      />
                    ))}
                  </OutlinedDiv>
                </div>
              </Fade>
            )}
          </div>
          <div style={{ alignItems: 'baseline' }} className={classes.separationBetween}>
            <div>
              <Button variant="contained" color="primary" startIcon={<AttachFile />} onClick={handleAttachment}>
                Adjuntar archivo
              </Button>
            </div>
          </div>
        </div>
      </Fade>
    </DropZone>
  );
};

export default ImproperRetention;
